
import React from 'react';
import { Link } from 'react-router-dom';
import { Card, CardContent } from '@/components/ui/card';
import { Leaf, Clock, ShieldCheck, ThumbsUp } from 'lucide-react';

const benefitsData = [
  {
    id: 1,
    title: "Eco-Friendly Products",
    description: "We use environmentally conscious cleaning solutions that are tough on dirt but gentle on the planet.",
    icon: <Leaf className="h-10 w-10 text-ventura-green" />
  },
  {
    id: 2,
    title: "Fast Turnaround",
    description: "Our efficient team ensures minimal disruption to your daily routine with quick, professional service.",
    icon: <Clock className="h-10 w-10 text-ventura-blue" />
  },
  {
    id: 3,
    title: "Satisfaction Guarantee",
    description: "If you're not completely satisfied with our work, we'll come back and make it right at no additional cost.",
    icon: <ShieldCheck className="h-10 w-10 text-ventura-blue" />
  },
  {
    id: 4,
    title: "Experienced Professionals",
    description: "Our trained technicians bring years of experience and expertise to every cleaning project.",
    icon: <ThumbsUp className="h-10 w-10 text-ventura-green" />
  }
];

const Benefits = () => {
  return (
    <section id="benefits" className="section-padding bg-ventura-lightGray">
      <div className="container mx-auto">
        <h2 className="section-title">Why Choose Us</h2>
        <p className="section-subtitle">
          Experience the Ventura Power Washing difference with our <Link to="/services" className="text-ventura-blue hover:text-ventura-darkBlue underline font-semibold">premium cleaning services</Link> and commitment to excellence
        </p>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mt-12">
          {benefitsData.map((benefit, index) => (
            <Card key={benefit.id} className={`card-shadow bg-white border-none animate-slide-in ${index % 2 === 0 ? 'border-l-4 border-l-ventura-blue' : 'border-l-4 border-l-ventura-green'}`} style={{ animationDelay: `${index * 0.1}s` }}>
              <CardContent className="p-6">
                <div className="flex items-start">
                  <div className={`mr-4 p-3 rounded-full ${index % 2 === 0 ? 'bg-blue-50' : 'bg-green-50'}`}>
                    {benefit.icon}
                  </div>
                  <div>
                    <h3 className="text-xl font-bold mb-2">{benefit.title}</h3>
                    <p className="text-gray-600">{benefit.description}</p>
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
        
        <div className="text-center mt-12">
          <Link to="/services" className="bg-ventura-blue text-white px-8 py-3 rounded-lg hover:bg-ventura-darkBlue transition-colors font-semibold inline-block">
            View All Services
          </Link>
        </div>
      </div>
    </section>
  );
};

export default Benefits;
